// Displays group page. Today there's only one display target (Complete
// Chutes board) but the page is structured to take more entries — extra
// monitor surfaces (warehouse status, sorter health, etc.) plug in as
// new AdminTile entries without restyling.
import { Monitor } from "lucide-react";
import AdminPageHeader from "../components/admin-page-header";
import AdminTile from "../components/admin/AdminTile";
import "../styles/admin-home.css";

const AdminDisplays = () => (
    <div className="page-data page-data-wide">
        <AdminPageHeader
            titleKey="displays"
            backTo="/admin"
            hideSearch
            crumbs={[
                { labelKey: "admin_panel", to: "/admin" },
                { labelKey: "displays" },
            ]}
        />
        <div className="admin-home-tiles">
            <AdminTile
                to="/complete-chutes"
                labelKey="complete_chutes"
                descriptionKey="tile_complete_chutes_desc"
                icon={<Monitor size={24} strokeWidth={1.5} />}
                tone="green"
            />
        </div>
    </div>
);

export default AdminDisplays;
